import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import type { CommunityAccessElementProps } from './CommunityAccessElement.types';

export function CommunityAccessElement({
  element,
  onClickButton,
  translations,
  children,
}: CommunityAccessElementProps) {
  const { data } = element.attrs || {};
  const community = data?.community ?? null;

  if (!community || data?.isBanned) {
    return null;
  }

  if (community.gated && !community.community_accessible) {
    return null;
  }

  const isMember = Boolean(data?.isMember);

  const tierNote = translations?.['manage.community.tier_note'];

  return (
    <SectionElement
      title={translations?.['manage.community.title'] || 'Community'}
      subTitle={
        translations?.['manage.community.description'] || 'Connect with other members and join the conversation.'
      }
    >
      {tierNote && <p className="text-sm text-gray-500">{tierNote}</p>}
      <ButtonElement variant="primary" onClick={onClickButton}>
        {isMember
          ? translations?.['manage.community.cta_member'] || 'Go to community'
          : translations?.['manage.community.cta_join'] || 'Join the community'}
      </ButtonElement>
      {children}
    </SectionElement>
  );
}
